import { buildQueryString } from '@izimi/utils';

import type FetchService from '../FetchService';
import type { ApiRequestQueryParamType, ApiResponseType } from '../types';

class PostalCodesApi {
  constructor(private fetchService: FetchService) {}

  getPostalCodes(params: ApiRequestQueryParamType<'listPostalCodes'>) {
    const qs = buildQueryString(params);
    return this.fetchService.get<ApiResponseType<'listPostalCodes'>>(`/postal-codes${qs}`);
  }
}

export default PostalCodesApi;
